/* eslint-disable tailwindcss/no-unnecessary-arbitrary-value */


import {
  cn
} from "@/lib/utils"


export const MaybeTabs = ({
  hasAvailableProduct,
  currentFabricArrayShowTabs,
  fabricLabel,
  currentProduct,
  setCurrentProduct,
  colorNumber,
  configurableColorNumber,
  className
}: {
  hasAvailableProduct: boolean,
  currentFabricArrayShowTabs: string[] | undefined,
  fabricLabel: string,
  currentProduct: string,
  setCurrentProduct: (product: "product" | "available_product") => void,
  colorNumber: number | undefined,
  configurableColorNumber: number | undefined,
  className?: string
}) => {
  
  if (!hasAvailableProduct) {
    return null
  }

  if (currentFabricArrayShowTabs && !currentFabricArrayShowTabs.includes(fabricLabel)) {
    return null
  }

  return (
    <div className={cn("border-b-1 flex gap-5 border-solid border-[#E7DED5]", className)}>
      <button
        type='button'
        className={cn("border-b-[4px] border-solid border-transparent capitalize leading-[50px] transition-all duration-300", currentProduct === "product" ? "border-[#BE9983] font-bold" : "border-transparent")}
        onClick={() => {
          const url = new URL(window.location.href)

          url.searchParams.delete("in-stock")
          window.history.replaceState({}, "", url)
          setCurrentProduct("product")
        }}
      >
        all({colorNumber || ""})
      </button>
      <button
        type='button'
        className={cn("border-b-[4px] border-solid border-transparent capitalize leading-[50px] transition-all duration-300", currentProduct === "available_product" ? "border-[#BE9983] font-bold" : "border-transparent")}
        onClick={() => setCurrentProduct("available_product")}>ship in 48hrs({configurableColorNumber || ""})
      </button>
    </div>
  )
}
